// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ty-z","tooltipWrapper":"uy-z","icon":"vy-z","tooltip":"wy-z","content":"xy-z"};